import { Switch, SwitchProps } from '@mui/material';
import type { CSSObject } from 'tss-react';
import { withStyles } from 'tss-react/mui';

export interface GVSwitchProps extends SwitchProps {
  'data-testid'?: string;
}

const StyledSwitch = withStyles(Switch, (theme) => ({
  root: {
    width: 28,
    height: 40,
    '&.MuiSwitch-root': {
      paddingLeft: 0,
      paddingRight: 0,
      overflow: 'visible',
      '.MuiSwitch-input': {
        width: 40, // Prevent excessive width switch input overlapping tooltip and preventing hover events.
      },
    },
  },
  switchBase: {
    padding: '14px 3.2px',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    '&.Mui-checked': {
      transform: 'translateX(9.6px) !important',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        opacity: '1 !important',
        backgroundColor: `${theme.palette.secondary.main} !important`,
        borderColor: `${theme.palette.secondary.main} !important`,
      },
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
    '&:hover .MuiSwitch-thumb::after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 16,
      height: 16,
      borderRadius: '50%',
      backgroundColor: 'rgba(255,255,255,0.12)',
      zIndex: 1,
      pointerEvents: 'none',
    } as CSSObject,
  },
  thumb: {
    width: 12,
    height: 12,
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
  },
  track: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: 25.6,
    height: 16,
    borderRadius: 10.5,
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(255,255,255,0.38)',
    opacity: 1,
  } as CSSObject,
  checked: {},
}));

const GVSwitch = (props: GVSwitchProps) => {
  const testId = props['data-testid'] || 'gv_switch';
  return <StyledSwitch {...props} disableRipple data-testid={testId} />;
};

export default GVSwitch;
